export default "__VITE_ASSET__RkISrZaQ__"